import type MetaInterface from '@/interfaces/MetaInterface';
  
  // This file is auto-generated by the build system.
  const meta: MetaInterface = {
    version: '1.0.2',
    date: '2026-08-05T14:17:39.068Z',
  };
  export default meta;
  